import { styled } from '@mui/system';

export const ActiveTab = styled('div')({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 1,
    backgroundColor: '#fff',
    width: '100px',
    height: 30,
    borderRadius: 4,
});
export const NonActiveTab = styled('div')({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 1,
    width: 100,
    height: 30,
    borderRadius: 4,
});

export const TabText = styled('div')({
    width: '80%',
    height: '8px',
    backgroundColor: '#dadae4',
    display: 'inline-block',
});

export const TabsContainer = styled('div')({
    backgroundColor: '#f4f4f6',
    padding: 8,
    marginBottom: 8,
    width: 'fit-content',
    borderRadius: 4,
});

export const ContentContainer = styled('div')({
    padding: 16,
    display: 'flex',
    overflow: 'hidden',
    flexDirection: 'column',
});
